export function formatMoney(value: string, fixed = 0) {
  if (!value) {
    return value;
  }

  const re = new RegExp(/\d(?=(\d{3})+$)/, 'g');
  const hasDot = (/\./g).test(value);
  /* istanbul ignore next */
  const [num = '', decimals = ''] = value.split('.');
  const money = num.replace(re, '$&,');

  if (hasDot && fixed > 0) {
    return `${money}.${decimals.substr(0, fixed)}`;
  }

  return money;
}
